import {userProps} from './user.props'

import * as Types from './types'
import {successGenerate} from "../common"
const INIT_STATE: userProps = {
  subUsers: [],
}

const userReducer = (state = INIT_STATE, {type, payload}: any) => {
  switch (type) {
    case successGenerate(Types.SUB_USER_LIST):
      return {
        ...state,
        subUsers: payload.data,
      }
    default:
      return state
  }
}

export {userReducer}
